import { useEffect } from 'react';

const PreloadResources = ({ resources = [] } = {}) => {
  useEffect(() => {
    const createdLinks = [];

    const createLink = (href, rel, as, type) => {
      // Check if link already exists
      const existing = document.querySelector(`link[href="${href}"][rel="${rel}"]`);
      if (existing) return null;

      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      if (as) link.as = as;
      if (type) link.type = type;

      // Add error handling
      link.onerror = () => console.warn(`Failed to preload: ${href}`);

      document.head.appendChild(link);
      createdLinks.push(link);
      return link;
    };

    // Default critical resources
    const defaultResources = [
      { href: '/assets/fonts/graphic-fonts/Graphik-Regular.woff2', rel: 'preload', as: 'font', type: 'font/woff2' },
      { href: '/assets/images/pdp/property-notavailable.png', rel: 'preload', as: 'image' },
      { href: '//fonts.googleapis.com', rel: 'dns-prefetch' },
      { href: '//www.hubzu.com', rel: 'dns-prefetch' }
    ];

    // Merge custom resources with defaults
    const allResources = [...defaultResources, ...resources];

    allResources.forEach(({ href, rel, as, type }) => {
      createLink(href, rel, as, type);
    });

    // Cleanup function
    return () => {
      createdLinks.forEach(link => {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
    };
  }, [resources]);

  return null;
};

export default PreloadResources;